import classNames from "classnames";
import Link from "next/link";
import * as React from "react";
import { Tweet } from "react-twitter-widgets";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import LazyImage from "@components/LazyImage";
import matchListItemStyles from "@components/MatchList/index.module.css";
import { paths } from "@libs/paths";
import { IFImg } from "@libs/utils/IFImg";
import { convertDayjs, dayjs, defaultTimeZone } from "@libs/utils/date";
import styles from "./index.module.css";

const FcTokyo202110: React.FC = () => {
  // xflagsTicket側でも応募締め切りを管理しているため
  // ページを開いた時間で応募の可否を判断する。
  const now = dayjs().tz(defaultTimeZone);
  const isEventFmarinosApplicationEnd =
    now >= convertDayjs("2021-10-26T13:00:00.000+09:00");
  const isEventSanfrecceApplicationEnd =
    now >= convertDayjs("2021-11-16T13:00:00.000+09:00");

  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={"FC東京をお店で応援しよう！キャンペーン"}
        description={
          "FC東京の試合をお店で上映！豪華賞品が当たるチャンスやオリジナル応援ドリンク、OB選手によるスペシャルイベントも。期間限定2021年12月4日まで"
        }
        ogUrl={paths.campaignFcTokyo202110}
        ogImage={`${process.env.APP_HOST}/img/campaign/fctokyo_202110/ogp.png`}
        canonicalUrl={paths.campaignFcTokyo202110}
      />
      <div className={styles.wrapper}>
        <div className={styles.close}>
          <p className={styles.closeText}>※このキャンペーンは終了しました</p>
        </div>
        <div className={styles.jumbotron}>
          <h1 className="md:none">
            <img
              src={IFImg("/img/campaign/fctokyo_202110/sp/jumbotron.png")}
              width={750}
              height={948}
              alt="FC東京をお店で応援しよう！キャンペーン"
            />
          </h1>

          <div className="none md:block">
            <img
              src={IFImg("/img/campaign/fctokyo_202110/pc/jumbotron.png")}
              width={2880}
              height={1284}
              alt="FC東京をお店で応援しよう！キャンペーン"
            />
          </div>

          <div className="none">
            ご来店者限定！FC東京オリジナル応援ドリンク
            フォロー＆リツイートで豪華賞品プレゼント
          </div>
        </div>

        <section
          className={classNames(styles.cSection, styles.cLightBg, styles.about)}
        >
          <div className={styles.container}>
            <h2 className={styles.cHeadingMedium}>
              <span className={styles.cHeadingMediumInner}>
                <span className={styles.cHeadingMediumInnerText}>
                  FC東京をお店で応援しよう！
                </span>
              </span>
            </h2>

            <div className={styles.aboutLeadText}>
              FC東京の試合をDAZN公式契約をする「FC東京応援店」で上映！豪華賞品が当たるチャンスやオリジナル応援ドリンクの販売、さらにOB選手によるスペシャルイベントも開催。スポーツはやっぱり仲間と観ると面白い！
            </div>
          </div>
        </section>

        <div
          className={classNames(styles.scheduleStoreWrapper, styles.cDarkBg)}
        >
          <section className={classNames(styles.cSection, styles.schedule)}>
            <div className={styles.container}>
              <h2 className={styles.cHeadingMedium}>
                <span className={styles.cHeadingMediumInner}>
                  <span className={styles.cHeadingMediumInnerText}>
                    FC東京の試合スケジュール
                  </span>
                </span>
              </h2>

              <div className={styles.shceduleLeadText}>
                以下の試合をDAZN公式契約をする「FC東京応援店」で上映！ご予約はお電話で。
              </div>

              <div className={styles.broadcastBoxWrapper}>
                <div
                  className={classNames(
                    matchListItemStyles.broadcastBox,
                    styles.broadcastBox
                  )}
                >
                  <div className={matchListItemStyles.link}>
                    <div
                      className={classNames(
                        matchListItemStyles.team,
                        styles.team
                      )}
                    >
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/fctokyo.png"
                            )})`,
                          }}
                        >
                          FC東京
                        </i>
                        <div className={matchListItemStyles.name}>FC東京</div>
                      </div>
                      <div>
                        <div
                          className={classNames(
                            matchListItemStyles.tournamentName,
                            styles.tournamentName
                          )}
                        >
                          明治安田
                          <br className={"md:none"} />
                          J1リーグ
                        </div>
                        <h3
                          className={classNames(
                            matchListItemStyles.tournamentDate,
                            styles.tournamentDate
                          )}
                        >
                          10/23(土)
                          <br />
                          14:00
                        </h3>
                      </div>
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/kashima_antlers.png"
                            )})`,
                          }}
                        >
                          鹿島アントラーズ
                        </i>
                        <div className={matchListItemStyles.name}>鹿島</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={classNames(
                    matchListItemStyles.broadcastBox,
                    styles.broadcastBox
                  )}
                >
                  <div className={matchListItemStyles.link}>
                    <div
                      className={classNames(
                        matchListItemStyles.team,
                        styles.team
                      )}
                    >
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/fctokyo.png"
                            )})`,
                          }}
                        >
                          FC東京
                        </i>
                        <div className={matchListItemStyles.name}>FC東京</div>
                      </div>
                      <div>
                        <div
                          className={classNames(
                            matchListItemStyles.tournamentName,
                            styles.tournamentName
                          )}
                        >
                          明治安田
                          <br className={"md:none"} />
                          J1リーグ
                        </div>
                        <h3
                          className={classNames(
                            matchListItemStyles.tournamentDate,
                            styles.tournamentDate
                          )}
                        >
                          11/3(水・祝)
                          <br />
                          14:00
                        </h3>
                      </div>
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/shimizu_spulse.png"
                            )})`,
                          }}
                        >
                          清水エスパルス
                        </i>
                        <div className={matchListItemStyles.name}>清水</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={classNames(
                    matchListItemStyles.broadcastBox,
                    styles.broadcastBox
                  )}
                >
                  <div className={matchListItemStyles.link}>
                    <div
                      className={classNames(
                        matchListItemStyles.team,
                        styles.team
                      )}
                    >
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/yokohama_f_marinos.png"
                            )})`,
                          }}
                        >
                          横浜F・マリノス
                        </i>
                        <div className={matchListItemStyles.name}>横浜FM</div>
                      </div>
                      <div>
                        <div
                          className={classNames(
                            matchListItemStyles.tournamentName,
                            styles.tournamentName
                          )}
                        >
                          明治安田
                          <br className={"md:none"} />
                          J1リーグ
                        </div>
                        <h3
                          className={classNames(
                            matchListItemStyles.tournamentDate,
                            styles.tournamentDate
                          )}
                        >
                          11/6(土)
                          <br />
                          16:00
                        </h3>
                      </div>
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/fctokyo.png"
                            )})`,
                          }}
                        >
                          FC東京
                        </i>
                        <div className={matchListItemStyles.name}>FC東京</div>
                      </div>

                      <div
                        className={classNames(
                          matchListItemStyles.ribbon,
                          styles.ribbon
                        )}
                      >
                        <span
                          className={classNames(
                            matchListItemStyles.label,
                            styles.label
                          )}
                        >
                          <span>スペシャルイベント</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={classNames(
                    matchListItemStyles.broadcastBox,
                    styles.broadcastBox
                  )}
                >
                  <div className={matchListItemStyles.link}>
                    <div
                      className={classNames(
                        matchListItemStyles.team,
                        styles.team
                      )}
                    >
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/fctokyo.png"
                            )})`,
                          }}
                        >
                          FC東京
                        </i>
                        <div className={matchListItemStyles.name}>FC東京</div>
                      </div>
                      <div>
                        <div
                          className={classNames(
                            matchListItemStyles.tournamentName,
                            styles.tournamentName
                          )}
                        >
                          明治安田
                          <br className={"md:none"} />
                          J1リーグ
                        </div>
                        <h3
                          className={classNames(
                            matchListItemStyles.tournamentDate,
                            styles.tournamentDate
                          )}
                        >
                          11/20(土)
                          <br />
                          14:00
                        </h3>
                      </div>
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/tokushima_vortis.png"
                            )})`,
                          }}
                        >
                          徳島ヴォルティス
                        </i>
                        <div className={matchListItemStyles.name}>徳島</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={classNames(
                    matchListItemStyles.broadcastBox,
                    styles.broadcastBox
                  )}
                >
                  <div className={matchListItemStyles.link}>
                    <div
                      className={classNames(
                        matchListItemStyles.team,
                        styles.team
                      )}
                    >
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/sanfrecce_hiroshima.png"
                            )})`,
                          }}
                        >
                          サンフレッチェ広島
                        </i>
                        <div className={matchListItemStyles.name}>広島</div>
                      </div>
                      <div>
                        <div
                          className={classNames(
                            matchListItemStyles.tournamentName,
                            styles.tournamentName
                          )}
                        >
                          明治安田
                          <br className={"md:none"} />
                          J1リーグ
                        </div>
                        <h3
                          className={classNames(
                            matchListItemStyles.tournamentDate,
                            styles.tournamentDate
                          )}
                        >
                          11/27(土)
                          <br />
                          14:00
                        </h3>
                      </div>
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/fctokyo.png"
                            )})`,
                          }}
                        >
                          FC東京
                        </i>
                        <div className={matchListItemStyles.name}>FC東京</div>
                      </div>

                      <div
                        className={classNames(
                          matchListItemStyles.ribbon,
                          styles.ribbon
                        )}
                      >
                        <span
                          className={classNames(
                            matchListItemStyles.label,
                            styles.label
                          )}
                        >
                          <span>スペシャルイベント</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={classNames(
                    matchListItemStyles.broadcastBox,
                    styles.broadcastBox
                  )}
                >
                  <div className={matchListItemStyles.link}>
                    <div
                      className={classNames(
                        matchListItemStyles.team,
                        styles.team
                      )}
                    >
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/fctokyo.png"
                            )})`,
                          }}
                        >
                          FC東京
                        </i>
                        <div className={matchListItemStyles.name}>FC東京</div>
                      </div>
                      <div>
                        <div
                          className={classNames(
                            matchListItemStyles.tournamentName,
                            styles.tournamentName
                          )}
                        >
                          明治安田
                          <br className={"md:none"} />
                          J1リーグ
                        </div>
                        <h3
                          className={classNames(
                            matchListItemStyles.tournamentDate,
                            styles.tournamentDate
                          )}
                        >
                          12/4(土)
                          <br />
                          14:00
                        </h3>
                      </div>
                      <div className={matchListItemStyles.cat}>
                        <i
                          className={classNames(
                            matchListItemStyles.logo,
                            styles.logo
                          )}
                          style={{
                            backgroundImage: `url(${IFImg(
                              "/img/team_icon/avispa_fukuoka.png"
                            )})`,
                          }}
                        >
                          アビスパ福岡
                        </i>
                        <div className={matchListItemStyles.name}>福岡</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.scheduleCautionText}>
                ※
                DAZNで配信される明治安田J1リーグのFC東京戦をDAZN公式契約をする「FC東京応援店」で上映いたします。
              </div>
            </div>
          </section>

          <section className={classNames(styles.cSection, styles.shop)}>
            <div className={styles.container}>
              <h2 className={styles.cHeadingMedium}>
                <span className={styles.cHeadingMediumInner}>
                  <span className={styles.cHeadingMediumInnerText}>
                    FC東京応援店
                  </span>
                </span>
              </h2>

              <div className={styles.shopCards}>
                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_hub_shibuya.png"
                      )}
                      width={686}
                      height={400}
                      alt="HUB渋谷店"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_hub_shibuya.png"
                      )}
                      width={303}
                      height={200}
                      alt="HUB渋谷店"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>HUB渋谷店</h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/Mz3mi2fG9nT2"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%B8%8B%E8%B0%B7%E5%8C%BA%E5%AE%87%E7%94%B0%E5%B7%9D%E7%94%BA3-10%20%E3%81%84%E3%81%A1%E3%81%94%E3%83%95%E3%82%A3%E3%82%A8%E3%82%B9%E3%82%BF%E6%B8%8B%E8%B0%B7%20B1F%2CHUB%E6%B8%8B%E8%B0%B7%E5%BA%97"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都渋谷区宇田川町3-10 いちごフィエスタ渋谷 B1F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      渋谷最古のHUBからFC東京を全力応援！！渋谷駅から徒歩7分、渋谷PARCO向かい地下1Fの店舗です！バモス東京！FC東京がある渋谷を。
                    </div>
                  </div>
                </div>

                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_failte.png"
                      )}
                      width={686}
                      height={400}
                      alt="Failte（フォルチェ）"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_failte.png"
                      )}
                      width={303}
                      height={200}
                      alt="Failte（フォルチェ）"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>
                        Failte（フォルチェ）
                      </h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/MDHy7Kwo4Gcz"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%B8%8B%E8%B0%B7%E5%8C%BA%E9%81%93%E7%8E%84%E5%9D%82%201-5-2%20%E6%B8%8B%E8%B0%B7SEDE%E3%83%93%E3%83%AB%205F%2CFailte%EF%BC%88%E3%83%95%E3%82%A9%E3%83%AB%E3%83%81%E3%82%A7%EF%BC%89"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都渋谷区道玄坂1-5-2 渋谷SEDEビル5F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      お一人様でもグループでも楽しめます！FC東京サポーターが集まる当店でパブフードとビール片手にみなさまでFC東京を応援しよう！
                    </div>
                  </div>
                </div>

                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_hub_sinjuku_nishiguchi_ogado.png"
                      )}
                      width={686}
                      height={400}
                      alt="HUB新宿西口大ガード店"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_hub_sinjuku_nishiguchi_ogado.png"
                      )}
                      width={303}
                      height={200}
                      alt="HUB新宿西口大ガード店"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>
                        HUB新宿西口大ガード店
                      </h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/Utk6O7g2l0c2"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%96%B0%E5%AE%BF%E5%8C%BA%E8%A5%BF%E6%96%B0%E5%AE%BF1-3-17%20%E6%96%B0%E5%AE%BF%E7%AC%AC%E4%B8%80%E3%82%A2%E3%82%AA%E3%82%A4%E3%83%93%E3%83%AB%20B1F%2CHUB%E6%96%B0%E5%AE%BF%E8%A5%BF%E5%8F%A3%E5%A4%A7%E3%82%AC%E3%83%BC%E3%83%89%E5%BA%97"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都新宿区西新宿 1-3-17 新宿第一アオイビルB1F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      新宿駅西口から徒歩3分！FC東京戦を全力で上映中！HUB全店舗の中でも特に大きなTVが完備された店舗で一緒に応援しましょう！
                    </div>
                  </div>
                </div>

                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_hub_+82_ikebukuro_wacca.png"
                      )}
                      width={686}
                      height={400}
                      alt="HUB+82池袋WACCA店"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_hub_+82_ikebukuro_wacca.png"
                      )}
                      width={303}
                      height={200}
                      alt="HUB+82池袋WACCA店"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>HUB+82池袋WACCA店</h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/cveHSjajfOBf"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E8%B1%8A%E5%B3%B6%E5%8C%BA%E6%9D%B1%E6%B1%A0%E8%A2%8B1-8-1%20WACCA%20IKEBUKURO%201F%2CHUB%2B82%E6%B1%A0%E8%A2%8BWACCA%E5%BA%97"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都豊島区東池袋1-8-1 WACCA IKEBUKURO1F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      FC東京を熱く全力で応援中！お店の場所は池袋駅東口を出て徒歩3分、WACCA池袋の建物内（1F）にあります！一緒に盛り上がりましょう♪
                    </div>
                  </div>
                </div>

                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_hub_kichijoji.png"
                      )}
                      width={686}
                      height={400}
                      alt="HUB吉祥寺店"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_hub_kichijoji.png"
                      )}
                      width={303}
                      height={200}
                      alt="HUB吉祥寺店"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>HUB吉祥寺店</h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/OW5pmZO7jmL2"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%AD%A6%E8%94%B5%E9%87%8E%E5%B8%82%E5%90%89%E7%A5%A5%E5%AF%BA%E6%9C%AC%E7%94%BA1-2-7%20%E5%90%89%E7%A5%A5%E5%AF%BA%E3%82%A2%E3%83%AB%E3%83%95%E3%82%A1%E3%83%93%E3%83%AB%20B1F%2CHUB%E5%90%89%E7%A5%A5%E5%AF%BA%E5%BA%97"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都武蔵野市吉祥寺本町 1-2-7 吉祥寺アルファビルB1F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      長く青赤の歴史と共に歩んできたHUBで応援しましょう！青赤フラッグ掲げて
                      集まれNo.12吉祥寺～♪勝つのは俺達だー
                    </div>
                  </div>
                </div>

                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_cafe_bar_livre.png"
                      )}
                      width={686}
                      height={400}
                      alt="Cafe Bar LIVRE"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_cafe_bar_livre.png"
                      )}
                      width={303}
                      height={200}
                      alt="Cafe Bar LIVRE"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>Cafe Bar LIVRE</h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/8w5FJIgSU2pi"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E4%B8%96%E7%94%B0%E8%B0%B7%E5%8C%BA%E6%9D%BE%E5%8E%9F2%E4%B8%81%E7%9B%AE42-5%20%E6%98%8E%E5%A4%A7%E5%89%8D%E3%83%95%E3%83%A9%E3%83%AF%E3%83%BC%E3%83%8F%E3%82%A4%E3%83%9B%E3%83%BC%E3%83%A02%E9%9A%8E%2CCafe%20Bar%20LIVRE"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都世田谷区松原2丁目42-5 明大前フラワーハイホーム2F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      2002年のオープンよりFC東京を応援してます。普段はゆるく、時には熱く！どうしても行けないAWAYやHOMEの味スタ後はお立ち寄り下さい！
                    </div>
                  </div>
                </div>

                <div className={styles.shopCard}>
                  <div className={styles.shopCardPhoto}>
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/shop_hub_chompchomp_akihabara.png"
                      )}
                      width={686}
                      height={400}
                      alt="HUBチョムチョム秋葉原店"
                      className={"md:none"}
                    />
                    <LazyImage
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/pc/shop_hub_chompchomp_akihabara.png"
                      )}
                      width={303}
                      height={200}
                      alt="HUBチョムチョム秋葉原店"
                      className={"none md:block"}
                    />
                  </div>
                  <div className={styles.shopCardTextWrapper}>
                    <div className={styles.shopCardNameWrapper}>
                      <h3 className={styles.shopCardName}>
                        HUBチョムチョム秋葉原店
                      </h3>
                      {/* 本番環境のURL */}
                      <Link
                        href="https://fansta.jp/shops/TcfSDsXxaCSU"
                        className={styles.shopCardDetailLink}
                        target="_blank"
                      >
                        詳細を見る
                      </Link>
                    </div>

                    <div className={styles.shopCardMapLink}>
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=%E6%9D%B1%E4%BA%AC%E9%83%BD%E5%8D%83%E4%BB%A3%E7%94%B0%E5%8C%BA%E7%A5%9E%E7%94%B0%E4%BD%90%E4%B9%85%E9%96%93%E7%94%BA1-13%20chomp%20chomp%20AKIHABARA%20B1F%2CHUB%E3%83%81%E3%83%A7%E3%83%A0%E3%83%81%E3%83%A7%E3%83%A0%E7%A7%8B%E8%91%89%E5%8E%9F%E5%BA%97"
                        className={styles.shopCardMapLinkAnchor}
                        target="_blank"
                      >
                        東京都千代田区神田佐久間町1-13 chomp chomp AKIHABARA B1F
                      </a>
                    </div>

                    <div className={styles.shopCardDescription}>
                      秋葉原駅から徒歩1分！チョムチョム秋葉原の地下1Fの店舗です！階段を下りると広々とした店内を青赤に染めて皆で盛り上がりましょう！
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.scheduleCautionText}>
                ※上記店舗はDAZN公式契約店になります。店舗によって一部の試合を上映しない場合がございます。詳細は店舗にお問い合わせください。
              </div>

              <div className="md:none">
                <Link
                  href="/shops?prefecture=13&teams=6&league=1"
                  className={styles.shopAllLink}
                  target="_blank"
                >
                  <span>FC東京応援店以外を含む店舗一覧</span>
                </Link>
              </div>
            </div>
          </section>
        </div>

        <section
          className={classNames(styles.cSection, styles.cLightBg, styles.drink)}
        >
          <div className={styles.container}>
            <h2 className={styles.cHeadingMedium}>
              <span className={styles.cHeadingMediumInner}>
                <span className={styles.cHeadingMediumInnerText}>
                  売上金の一部がクラブ運営費に！
                </span>
              </span>
              <br />
              <span className={styles.cHeadingMediumInner}>
                <span className={styles.cHeadingMediumInnerText}>
                  FC東京応援ドリンク
                </span>
              </span>
            </h2>

            <div className={styles.drinkImage}>
              <div className={styles.drinkImageText}>
                <img
                  src={IFImg("/img/campaign/fctokyo_202110/sp/drink.svg")}
                  className={styles.drinkImageTextImg}
                  width="180"
                  height="45"
                  alt="DRINK"
                />
              </div>
              <LazyImage
                src={IFImg("/img/campaign/fctokyo_202110/sp/drink-image.jpg")}
                width={750}
                height={480}
                alt="購入者限定 ステッカープレゼント ※写真はイメージです"
                className={"md:none"}
              />
              <LazyImage
                src={IFImg("/img/campaign/fctokyo_202110/pc/drink-image.jpg")}
                width={942}
                height={400}
                alt="購入者限定 ステッカープレゼント ※写真はイメージです"
                className={"none md:block"}
              />
            </div>
          </div>

          <div className={classNames(styles.cDarkBg, styles.cBgPadding)}>
            <div className={styles.container}>
              <div className={styles.drinkAboutText}>
                期間限定でFC東京応援店で販売！売上金の一部がクラブ運営費に充てられます。チームの強化をサポートしよう！
              </div>

              <dl className={styles.cDetailList}>
                <dt className={styles.cDetailListTitle}>
                  <h4>注意事項</h4>
                </dt>
                <dd className={styles.cDetailListData}>
                  ・2021年10月23日(土) から
                  2021年12月4日(土)まで本ページ記載のFC東京応援店にて販売します。（Failte（フォルチェ）は試合上映日のみ販売となります。）
                  <br />
                  ・店舗によってドリンクの内容、種類、価格が異なります。詳細は各店舗にお問い合わせください。
                  <br />
                  ・本特典は商品がなくなり次第終了となります。また、商品の内容は変更となる場合があります。
                </dd>
              </dl>
            </div>
          </div>
        </section>

        <section
          className={classNames(
            styles.cSection,
            styles.cLightBg,
            styles.talkEvent
          )}
        >
          <h2 className={styles.cHeadingMedium}>
            <span className={styles.cHeadingMediumInner}>
              <span className={styles.cHeadingMediumInnerText}>
                OB対決!?スペシャルイベント
              </span>
            </span>
          </h2>

          <section className={styles.talkEventLive}>
            <div className={classNames(styles.talkEventLiveBg, "md:none")}>
              <img
                src={IFImg(
                  "/img/campaign/fctokyo_202110/sp/talk-event-live01-bg.jpg"
                )}
                alt=""
              />
            </div>

            <div
              className={classNames(styles.talkEventLiveBg, "none md:block")}
            >
              <img
                src={IFImg(
                  "/img/campaign/fctokyo_202110/pc/talk-event-live01-bg.jpg"
                )}
                alt=""
              />
            </div>

            <div className={styles.container}>
              <div className={styles.talkEventLiveHeading}>
                <img
                  src={IFImg(
                    "/img/campaign/fctokyo_202110/sp/tark-event-live01-heading.svg"
                  )}
                  className={styles.talkEventLiveHeadingImg}
                  width="199"
                  height="47"
                  alt="LIVE 01"
                />
              </div>

              <div className={styles.talkEventAvatars}>
                <div
                  className={classNames(
                    styles.talkEventAvatarWrapper,
                    styles.talkEventAvatarWrapper01
                  )}
                >
                  <div
                    className={styles.talkEventAvatar}
                    style={{ width: "auto", marginRight: "-12px" }}
                  >
                    <img
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/talk-event-live01-avatar-01.png"
                      )}
                      className={styles.talkEventAvatarImg}
                      width="80"
                      height="80"
                      alt="FC東京/横浜F・マリノスOB：坂田 大輔氏"
                    />
                    <div className={styles.talkEventAvatarName}>
                      <span>FC東京/横浜F・マリノスOB</span>
                      坂田 大輔氏
                    </div>
                  </div>

                  <div className={styles.talkEventX}>
                    <img
                      src={IFImg("/img/campaign/fctokyo_202110/sp/x.svg")}
                      className={styles.talkEventXImg}
                      width="85"
                      height="85"
                      alt=""
                    />
                  </div>

                  <div className={styles.talkEventAvatar}>
                    <img
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/talk-event-live01-avatar-02.png"
                      )}
                      className={styles.talkEventAvatarImg}
                      width="80"
                      height="80"
                      alt="FC東京OB：徳永 悠平氏"
                    />
                    <div className={styles.talkEventAvatarName}>
                      <span>FC東京OB</span>徳永 悠平氏
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.talkEventTextWrapper}>
                <div className={styles.talkEventTextAbout}>
                  <h3 className={styles.talkEventTitle}>
                    DAZN主催パブリックビューイング
                    <i className="md:none"> </i>
                    <br className="none md:block" />
                    明治安田J1リーグ
                    <i className="md:none"> </i>
                    <br className="none md:block" />
                    第35節 横浜F・マリノス VS FC東京
                  </h3>
                  <p className={styles.talkEventDescription}>
                    FC東京OBの徳永氏とFC東京/横浜F・マリノスOBの坂田氏が登場、2人のライブトークも楽しめます。試合中の実況・解説はもちろん、現役時代の対戦エピソードや同世代ならではのマル秘話が聞けるかも?!
                  </p>
                </div>

                <div className={styles.talkEventDetail}>
                  <dl className={styles.talkEventDetailList}>
                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        開催日時
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      {/* eslint-disable-next-line no-irregular-whitespace */}
                      2021年11月6日(土) 　開場: 15:00　開演: 15:30（キックオフ
                      16:00）
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>会場</h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      <a
                        href="https://fansta.jp/shops/Mz3mi2fG9nT2"
                        target="_blank"
                      >
                        HUB渋谷店
                      </a>
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        チケット [抽選販売]
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      {/* eslint-disable-next-line no-irregular-whitespace */}
                      A席：3,000円(税込)　B席：1,500円(税込)
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        応募期間
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      2021年10月19日(火) 13:00 〜 2021年10月26日(火) 13:00
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        当選発表
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      2021年10月28日(木)
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        応募方法
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      チケットの応募受付は「XFLAG
                      TICKET」で行います。応募にはXFLAG
                      IDの登録が必要になります。
                    </dd>
                  </dl>

                  {!isEventFmarinosApplicationEnd && (
                    <a
                      href="https://event.xflag.com/events/fctokyo_20211106_fmarinos"
                      target="_blank"
                      className={styles.talkEventDetailButton}
                    >
                      <span className={styles.talkEventDetailButtonText}>
                        抽選に応募する
                      </span>
                    </a>
                  )}
                  {isEventFmarinosApplicationEnd && (
                    <span
                      className={classNames(
                        styles.talkEventDetailButton,
                        styles.disabled
                      )}
                    >
                      <span className={styles.talkEventDetailButtonText}>
                        応募期間は終了しました
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          </section>

          <section className={styles.talkEventLive}>
            <div className={classNames(styles.talkEventLiveBg, "md:none")}>
              <img
                src={IFImg(
                  "/img/campaign/fctokyo_202110/sp/talk-event-live02-bg.jpg"
                )}
                alt=""
              />
            </div>

            <div
              className={classNames(styles.talkEventLiveBg, "none md:block")}
            >
              <img
                src={IFImg(
                  "/img/campaign/fctokyo_202110/pc/talk-event-live02-bg.jpg"
                )}
                alt=""
              />
            </div>

            <div className={styles.container}>
              <div className={styles.talkEventLiveHeading}>
                <img
                  src={IFImg(
                    "/img/campaign/fctokyo_202110/sp/tark-event-live02-heading.svg"
                  )}
                  className={styles.talkEventLiveHeadingImg}
                  width="199"
                  height="47"
                  alt="LIVE 02"
                />
              </div>

              <div className={styles.talkEventAvatars}>
                <div className={styles.talkEventAvatarWrapper}>
                  <div className={styles.talkEventAvatar}>
                    <img
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/talk-event-live02-avatar-01.png"
                      )}
                      className={styles.talkEventAvatarImg}
                      width="80"
                      height="80"
                      alt="サンフレッチェ広島OB：山岸 智氏"
                    />
                    <div className={styles.talkEventAvatarName}>
                      <span>サンフレッチェ広島OB</span>山岸 智氏
                    </div>
                  </div>

                  <div className={styles.talkEventX}>
                    <img
                      src={IFImg("/img/campaign/fctokyo_202110/sp/x.svg")}
                      className={styles.talkEventXImg}
                      width="85"
                      height="85"
                      alt=""
                    />
                  </div>

                  <div className={styles.talkEventAvatar}>
                    <img
                      src={IFImg(
                        "/img/campaign/fctokyo_202110/sp/talk-event-live01-avatar-02.png"
                      )}
                      className={styles.talkEventAvatarImg}
                      width="80"
                      height="80"
                      alt="FC東京OB：徳永 悠平氏"
                    />
                    <div className={styles.talkEventAvatarName}>
                      <span>FC東京OB</span>徳永 悠平氏
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.talkEventTextWrapper}>
                <div className={styles.talkEventTextAbout}>
                  <h3 className={styles.talkEventTitle}>
                    DAZN主催パブリックビューイング
                    <i className="md:none"> </i>
                    <br className="none md:block" />
                    明治安田J1リーグ
                    <i className="md:none"> </i>
                    <br className="none md:block" />
                    第37節 サンフレッチェ広島 VS FC東京
                  </h3>
                  <p className={styles.talkEventDescription}>
                    FC東京OBの徳永氏とサンフレッチェ広島OBの山岸氏が登場、2人のライブトークも楽しめます。試合中の実況・解説はもちろん、現役時代の対戦エピソードや同世代ならではのマル秘話が聞けるかも?!
                  </p>
                </div>

                <div className={styles.talkEventDetail}>
                  <dl className={styles.talkEventDetailList}>
                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        開催日時
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      {/* eslint-disable-next-line no-irregular-whitespace */}
                      2021年11月27日(土) 　開場: 13:00　開演: 13:30（キックオフ
                      14:00）
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>会場</h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      <a
                        href="https://fansta.jp/shops/Mz3mi2fG9nT2"
                        target="_blank"
                      >
                        HUB渋谷店
                      </a>
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        チケット [抽選販売]
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      {/* eslint-disable-next-line no-irregular-whitespace */}
                      A席：3,000円(税込)　B席：1,500円(税込)
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        応募期間
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      ① 2021年10月19日(火) 13:00 〜 2021年11月9日(火) 13:00
                      <br />② 2021年11月9日(火) 13:01 〜 2021年11月16日(火)
                      13:00
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        当選発表
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      ① 2021年11月11日(木)
                      <br />
                      ② 2021年11月18日(木)
                      <br />
                      ※応募期間②を追加しました。（追記: 2021年11月5日）
                    </dd>

                    <dt className={styles.talkEventDetailTitle}>
                      <h4 className={styles.talkEventDetailTitleText}>
                        応募方法
                      </h4>
                    </dt>
                    <dd className={styles.talkEventDetailData}>
                      チケットの応募受付は「XFLAG
                      TICKET」で行います。応募にはXFLAG
                      IDの登録が必要になります。
                    </dd>
                  </dl>

                  {!isEventSanfrecceApplicationEnd && (
                    <a
                      href="https://event.xflag.com/events/fctokyo_20211127_sanfrecce"
                      target="_blank"
                      className={styles.talkEventDetailButton}
                    >
                      <span className={styles.talkEventDetailButtonText}>
                        抽選に応募する
                      </span>
                    </a>
                  )}
                  {isEventSanfrecceApplicationEnd && (
                    <span
                      className={classNames(
                        styles.talkEventDetailButton,
                        styles.disabled
                      )}
                    >
                      <span className={styles.talkEventDetailButtonText}>
                        応募期間は終了しました
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          </section>
        </section>

        <section
          className={classNames(
            styles.cSection,
            styles.cDarkBg,
            styles.benefits
          )}
        >
          <h2 className={styles.cHeadingMedium}>
            <span className={styles.cHeadingMediumInner}>
              <span className={styles.cHeadingMediumInnerText}>
                期間限定！お得な特典
              </span>
            </span>
          </h2>
          <div className={styles.benefitsItems}>
            <section className={styles.benefitsItem}>
              <div className={styles.container}>
                <div className={styles.benefitsItemImage}>
                  <LazyImage
                    src={IFImg(
                      "/img/campaign/fctokyo_202110/sp/benefits-image-01.jpg"
                    )}
                    width={750}
                    height={480}
                    alt="特典01：Amazon ギフト券"
                    className={"md:none"}
                  />
                  <LazyImage
                    src={IFImg(
                      "/img/campaign/fctokyo_202110/pc/benefits-image-01.jpg"
                    )}
                    width={942}
                    height={400}
                    alt="特典01：Amazon ギフト券"
                    className={"none md:block"}
                  />
                  <div className={styles.benefitsItemImageText}>
                    <img
                      src={IFImg("/img/campaign/fctokyo_202110/sp/01.svg")}
                      className={styles.benefitsItemImageTextImg}
                      width="63"
                      height="47"
                      alt="01"
                    />
                  </div>
                </div>
              </div>

              <div
                className={classNames(styles.benefitsItemName, styles.cLightBg)}
              >
                <div className={styles.container}>
                  <h3 className={styles.benefitsItemNameText}>
                    <span>来店時アンケート＆ホーム画面追加で</span>Amazon
                    ギフト券500円分
                  </h3>
                </div>
              </div>

              <div className={classNames(styles.cLightBg, styles.cBgPadding)}>
                <div className={styles.container}>
                  <div className={styles.benefitsItemAboutText}>
                    FC東京の試合上映日にFC東京応援店へご来店いただき、アンケート回答＆Fanstaをホーム画面に追加された方全員にAmazon
                    ギフト券500円分をお渡しします。詳細はお店の方にお声がけください。
                    <br />
                    <br />
                    <strong>
                      <a
                        href="https://twitter.com/fansta_jp/status/1451493121032785923"
                        target="_blank"
                      >
                        ※ ホーム画面追加の方法はこちら
                      </a>
                    </strong>
                  </div>

                  <dl className={styles.cDetailList}>
                    <dt className={styles.cDetailListTitle}>
                      <h4>注意事項</h4>
                    </dt>
                    <dd className={styles.cDetailListData}>
                      ・本ページ記載のFC東京の試合上映日にFC東京応援店にご来店いただいた方が対象となります。
                      <br />
                      ・本特典はおひとり様1日1回のみとなり、期間中おひとり様最大6回（上映試合日程分）までとなります。
                      <br />
                      ・本特典は先着順となり、期間中上限に達した場合は予告なく終了いたします。
                    </dd>
                  </dl>
                </div>
              </div>
            </section>

            <section className={styles.benefitsItem}>
              <div className={styles.container}>
                <div className={styles.benefitsItemImage}>
                  <LazyImage
                    src={IFImg(
                      "/img/campaign/fctokyo_202110/sp/benefits-image-02.jpg"
                    )}
                    width={750}
                    height={480}
                    alt="特典02：Twitterフォロー&リツイートで抽選8名様に"
                    className={"md:none"}
                  />
                  <LazyImage
                    src={IFImg(
                      "/img/campaign/fctokyo_202110/pc/benefits-image-02.jpg"
                    )}
                    width={942}
                    height={400}
                    alt="特典02：Twitterフォロー&リツイートで抽選8名様に"
                    className={"none md:block"}
                  />
                  <div className={styles.benefitsItemImageText}>
                    <img
                      src={IFImg("/img/campaign/fctokyo_202110/sp/02.svg")}
                      className={styles.benefitsItemImageTextImg}
                      width="63"
                      height="47"
                      alt="01"
                    />
                  </div>
                </div>
              </div>

              <div
                className={classNames(styles.benefitsItemName, styles.cLightBg)}
              >
                <div className={styles.container}>
                  <h3 className={styles.benefitsItemNameText}>
                    <span>Twitterフォロー&リツイートで抽選8名様に</span>
                    豪華賞品プレゼント！
                  </h3>
                </div>
              </div>

              <div className={classNames(styles.cLightBg, styles.cBgPadding)}>
                <div className={styles.container}>
                  <div className={styles.benefitsItemAboutText}>
                    TwitterのFansta公式アカウントをフォロー&リツイートで抽選8名様に豪華賞品プレゼント。
                  </div>

                  <dl className={styles.cDetailList}>
                    <dt className={styles.cDetailListTitle}>
                      <h4>応募方法</h4>
                    </dt>
                    <dd className={styles.cDetailListData}>
                      以下の2ステップで応募完了！
                      <br />
                      1. Fansta公式アカウントをフォロー
                      <div className={styles.twitterFollow}>
                        <a
                          href="https://twitter.com/intent/follow?screen_name=fansta_jp"
                          target="_blank"
                        >
                          <img
                            src={IFImg(
                              "/img/campaign/fctokyo_202110/sp/btn-twitter-follow.png"
                            )}
                            className={styles.twitterFollowImage}
                            width="149"
                            height="28"
                            alt="@fansta_jpさんをフォロー"
                          />
                        </a>
                      </div>
                      2. こちらをリツイート（※このキャンペーンは終了しました。）
                      <Tweet tweetId="1450309377655599109" />
                    </dd>

                    <dt className={styles.cDetailListTitle}>
                      <h4>賞品</h4>
                    </dt>
                    <dd className={styles.cDetailListData}>
                      ・観戦チケット（12月4日(土) 第38節 FC東京 VS
                      アビスパ福岡） : メインS指定席 ペア3組
                      <br />
                      ・長友佑都選手 or 森重真人選手サイン入りボール: 各1名様
                      <br />
                      ・森重真人選手 or
                      東慶悟選手サイン入りユニフォーム（サイズL）: 各1名様
                      <br />
                      ・小川諒也選手サイン入りスパイク: 1名様
                      <br />
                      ※賞品はお選びいただけません。予めご了承ください。
                    </dd>

                    <dt className={styles.cDetailListTitle}>
                      <h4>応募期間</h4>
                    </dt>
                    <dd className={styles.cDetailListData}>
                      2021年10月19日(火) 13:00 〜 2021年12月4日(土) 23:59
                      <br />※ 観戦チケットの応募のみ 11/4(木)
                      12:00で締切り、その時点の応募者から抽選を行います。
                    </dd>

                    <dt className={styles.cDetailListTitle}>
                      <h4>応募条件</h4>
                    </dt>
                    <dd className={styles.cDetailListData}>
                      ・当選発表までにフォローを外したり、リツイートを削除した場合、応募が無効となります。予めご了承ください。
                      <br />
                      ・当選した方にはTwitterのDMでご連絡いたします。DM送信後2日以内にご返信がなかった場合、当選は無効とさせていただきますのでご注意ください。
                      <br />・
                      <a href="#terms-twitter" style={{ color: "inherit" }}>
                        注意事項
                      </a>
                      をよく読み同意のうえご応募ください。
                    </dd>
                  </dl>
                </div>
              </div>
            </section>
          </div>

          <div className={styles.benefitsContact}>
            <div className={styles.container}>
              <span className={styles.benefitsContactAnchor}>
                <span>
                  {/* eslint-disable-next-line no-irregular-whitespace */}
                  <i className={"md:none"}>　</i>
                  本キャンペーンについてのお問い合わせは、
                  <br className={"md:none"} />
                  <a
                    href="https://support.fansta.jp/hc/ja/requests/new"
                    target="_blank"
                  >
                    Fanstaお問い合わせ窓口
                  </a>
                  までお願いいたします。
                </span>
              </span>
            </div>
          </div>
        </section>

        <section className={classNames(styles.cSection, styles.terms)}>
          <div className={styles.container}>
            <h2 className={styles.cHeadingMedium}>
              <span className={styles.cHeadingMediumInner}>
                <span className={styles.cHeadingMediumInnerText}>注意事項</span>
              </span>
            </h2>

            <div className={styles.termsContent}>
              <div>
                ・本ページ記載の各特典は、本ページ記載の対象試合が中止・日程変更となった場合や本ページ記載の対象店舗が閉店・休業となった場合や株式会社ミクシィ（以下、「弊社」といいます）の任意の事情で、予告なく変更・中断・中止・終了することがあります。また、本注意事項は予告なく変更することがあります。これらの変更、中断、中止、終了そのほか各特典や賞品に起因して生じる損害やトラブルについては、弊社は、弊社の責に帰すべき事由による場合を除き、一切の責任を追うものではありません。
                <br />
                ・各特典の注意事項は以下をよくお読みください。
              </div>
            </div>

            <div className={styles.termsContent}>
              <div className={styles.termsHeading}>
                売上金の一部がクラブ運営費に！FC東京応援ドリンク
              </div>
              <div>
                ・2021年10月23日(土) から
                2021年12月4日(土)まで本ページ記載のFC東京応援店にて販売します。（Failte（フォルチェ）は試合上映日のみ販売となります。）
                <br />
                ・店舗によってドリンクの内容、種類、価格が異なります。詳細は各店舗にお問い合わせください。
                <br />
                ・本特典は商品がなくなり次第終了となります。また、商品の内容は変更となる場合があります。
              </div>
            </div>

            <div className={styles.termsContent}>
              <div className={styles.termsHeading}>
                OB対決!?ライブトークイベント
              </div>
              <div>
                ・本イベントの注意事項は「
                <a href="https://event.xflag.com/" target="_blank">
                  XFLAG TICKET
                </a>
                」の本イベントについての記載をご確認ください。
              </div>
            </div>

            <div className={styles.termsContent}>
              <div className={styles.termsHeading}>
                来店時アンケート＆ホーム画面追加でAmazon ギフト券500円分
              </div>
              <div>
                ・本ページ記載のFC東京の試合上映日にFC東京応援店にご来店いただいた方が対象となります。
                <br />
                ・本特典はおひとり様1日1回のみとなり、期間中おひとり様最大6回（上映試合日程分）までとなります。
                <br />
                ・本特典は先着順となり、期間中上限に達した場合は予告なく終了いたします。
                <br />
                ・※本特典は弊社による提供です。本特典についてのお問い合わせはAmazonではお受けしておりません。お問い合わせは
                <a
                  href="https://support.fansta.jp/hc/ja/requests/new"
                  target="_blank"
                >
                  こちら
                </a>
                までお願いいたします。
                <br />
                ・※Amazon、Amazon.co.jpおよびそれらのロゴはAmazon.com, Inc.
                またはその関連会社の商標です。
              </div>
            </div>

            <div className={styles.termsContent} id="terms-twitter">
              <div className={styles.termsHeading}>
                Twitterフォロー&リツイートで抽選8名様に豪華賞品プレゼント！
              </div>
              <div>
                ・本特典は、賞品の内容を含め、予告なく変更、中止、終了することがあります。
                <br />
                ・本特典に参加する場合には、Twitterの利用規約またはルール等に従ってください。
                <br />
                ・以下の場合は本特典への応募及び当選を無効といたします。
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・複数のTwitterアカウントを利用して応募した場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・当選者選出時にフォローが解除されている場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・当選者選出時にリツイートが削除されている場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・当選者選出時にTwitterアカウントが削除・変更されている場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・Twitterアカウントを非公開にしている場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・Twitterを退会した場合
                <br />
                ・当選発表の日程はあくまでも目安になるため、日程が前後する場合がございます。
                <br />
                ・当選者には@fansta_jpからご応募いただいたTwitterアカウント宛にダイレクトメッセージ（DM）にて賞品発送のご案内をいたします。
                <br />
                ・賞品発送のため、当選したお客様は別途お届け先情報のご連絡が必要となります。
                <br />
                ・以下の場合は当選を無効といたします。
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・メッセージでのご案内に従っていただけない場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・当選お知らせのDMに2日以内にご返信がなかった場合
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・当選お知らせのDMが送信/受信できなかった場合（また、いかなる場合においてもDMは再発行いたしません。）
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・お届け先情報の不備またはお客様の都合（不在、転居等）で当選賞品をお届けできない場合（また、賞品の再発送はいたしません。）
                <br />
                {/* eslint-disable-next-line no-irregular-whitespace */}
                　・弊社社員及び関係者の応募は無効といたします。
                <br />
                ・応募対象者は、日本国内在住のTwitterアカウントをお持ちの方、応募方法に記載されている内容を正しく対応いただけている方に限ります。
                <br />
                ・未成年の方は保護者の同意を得た上でご応募ください。
                <br />
                ・抽選及び当選に関するお問い合わせには、お答えしかねますのであらかじめご了承ください。
                <br />
                ・当選の権利は当選者本人のみが行使できるものとし第三者への譲渡、転売、換金を禁止します。
                <br />
                ・お客様が不正行為等を行ったと弊社が判断した場合、当選は無効となります。
                <br />
                ・賞品の受け取りは国内に限ります。海外への送付、お届けは出来かねます。
                <br />
                ・本特典への参加に関し、対象者と第三者との間に紛争が生じた場合、当該対象者は自らの責任と費用負担によりその紛争を解決し、弊社に一切損害を与えないものとします。
                <br />
                ・弊社が必要と判断した場合、本注意事項などを自由に変更でき、本特典の適切な運用を確保するために必要なあらゆる対応を取ることができるものとします。対象者は本特典の運営方法に従うものとし、その運営方法に対し一切異議などを申し立てないものとします。
                <br />
                ・ネットワークの不具合、コンピューターウイルスの影響及びサーバーへの不正アクセスなど弊社の支配が及ばない事態及びそれに関連して生じた対象者の損害などについて、弊社は一切の責任を負わないものとします。
                <br />
                ・弊社は、本特典を通じて当社が取得したお客様の個人情報を、別途定める「
                <a
                  href="https://mixi.co.jp/privacy/#toriatsukai"
                  target="_blank"
                >
                  プライバシーポリシー／個人情報の取扱い
                </a>
                」に基づき管理します。
                <br />
                ・弊社は、当該個人情報を、本特典の運営を目的として使用いたします。
                <br />
                ・本注意事項の解釈・適用に関しましては、日本国法に準拠するものといたします。また、本注意事項に関する紛争については、東京地方裁判所または東京簡易裁判所をもって第一審の専属的合意管轄裁判所とします。
              </div>
            </div>
          </div>
        </section>

        <section className={styles.fansta}>
          <div className={styles.container}>
            <h2 className={styles.fanstaTitle}>
              <img
                src={IFImg("/img/logo_fansta.svg")}
                height="32"
                alt="Fansta"
                className={styles.fanstaTitleImage}
              />
            </h2>

            <div className={styles.fanstaText}>
              Fanstaは、試合・エリア・チームから
              <br className={"md:none"} />
              DAZN上映店舗を探せる
              <br />
              全く新しいサービスです。
            </div>

            <div>
              <Link href={paths.home} className={styles.fanstaTopButton}>
                <span>Fanstaトップへ</span>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </CommonLayout>
  );
};

export default FcTokyo202110;
